module.exports = __webpack_public_path__ + "img/AM.8cf75892.png";